import { defineStore } from "pinia";
import { socket } from '@/user.socket';
import { useResponseMessageStore } from "./response_message";
import http from "@/composables/axios";

export const useJackpotStore = defineStore("jackpot", {
  state: () => ({
    selections: {}, 
    sendingJackpot:false,
    jackpotTickets:[],
    jackpotTicketsUsers:[],
    lastDailyJackpots:[],
    lastWeeklyJackpots:[]
  }),
  getters: {
    getTickets: (state) => state.jackpotTickets,
    getTicketsUsers: (state) => state.jackpotTicketsUsers,
    getLastDailyJackpots: (state) => state.lastDailyJackpots,
    getLastWeeklyJackpots: (state) => state.lastWeeklyJackpots,
    getSendingJackpot: (state) => state.sendingJackpot
  },
  actions: {
    toggleOdd(eventId, odd) {
      if (!this.selections[eventId]) {
        this.selections[eventId] = {}
      }
      const eventSelections = this.selections[eventId]
      if (eventSelections[odd.i]) {
        delete eventSelections[odd.i]

        if (Object.keys(eventSelections).length === 0) {
          delete this.selections[eventId]
        }
        return
      }

      this.selections[eventId] = {
        [odd.i]: odd
      }
    },

    quickPick(allSelectionsMap) {
      for (const key in this.selections) {
        delete this.selections[key];
      }
      const newSelections = {};
      for (const eventId in allSelectionsMap) {
        const markets = allSelectionsMap[eventId];
        if (!markets?.length) continue;

        const odds = markets[0]?.o || []
        const main = odds.filter(o => ['1', 'X', '2'].includes(o.n) && o.st != 2)
        if (!main.length) continue

        const randomOdd = main[Math.floor(Math.random() * main.length)]
        newSelections[eventId] = {
          [randomOdd.i]: randomOdd
        };
      }
      this.selections = { ...newSelections };
    },

    clearAll() {
      this.selections = {};
    },

    send(cur_id, slips, daily) {
      try {
        this.sendingJackpot = true
          const ticketData = {
            cur_id:cur_id,
            slips: slips,
            daily: daily,
          }
        socket.emit('ticket:jackpot', ticketData)
      } catch (error) {
          this.sendingJackpot = false
          console.error(error.message)
      }
    },

    clear() {
      this.sendingJackpot = false
      this.slips = {}
    },

    bindSocketJackpots() {
      const responseMessageStore = useResponseMessageStore()
      socket.on('ticket:jackpot', (data) => {
        if (data.ok) {
          responseMessageStore.setMessage(data.message, {extra: data.extra})
          this.clear()
        }else {
          this.sendingJackpot = false
          responseMessageStore.setMessage(data.message)
        }
      })
    },

    async fetchJackpotTickets(query){
      query = new URLSearchParams(query).toString()
      await http.get(`01/jackpot-tickets?${query}`).then(res => {
        if(res.data.ok){
          this.jackpotTickets = res.data.data.groups
          this.jackpotTicketsUsers = res.data.data.users
        }
      })
    },

    async fetchLastWeeklyJackpots(){
      await http.get(`07/actual-jp?daily=0`).then(res => {
        if(res.status == 200){
          this.lastWeeklyJackpots = res.data
        }
      })
    },

    async fetchLastDailyJackpots(){
      await http.get(`07/actual-jp?daily=1`).then(res => {
        if(res.status == 200){
          this.lastDailyJackpots = res.data
        }
      })
    }
  },
});
